import {
  createRouter,
  createWebHistory,
} from 'vue-router';

import guards, { GuardError } from '@router/guards';
import routes from '@router/routes';
import { ENTRY_POINTS } from '@constants/entry-points';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  (async () => {
    try {
      await guards.reduce(async (previous, guard) => {
        await previous;
        return guard(to, from);
      }, Promise.resolve());
      document.title = to.meta.title as string;
      next();
    } catch (error: unknown) {
      if (error instanceof GuardError) {
        console.error(error.message);
        error.callback();
        next(error.redirectTo);
      } else {
        console.error(error);
        next(ENTRY_POINTS.PATH.UNAUTHORIZED());
      }
    }
  })();
});

export default router;
